var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 56,
    viewBox: "0 0 41 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5861 55.3165H20.8011L15.3221 51.4783L23.5861 36.8778L12.7802 36.7703L7.27393 32.5773C7.80308 31.6817 12.0482 31.6097 12.0482 31.6097C15.6409 25.6039 19.3223 15.9588 26.5076 4L31.9412 7.90276L29.1562 26.3414L34.5557 22.901L38.9037 26.3414C38.8371 26.2925 40.4633 27.2107 40.2127 27.6848L40.0177 28.0799C29.0448 46.2289 23.5861 55.3165 23.5861 55.3165Z",
    fill: "url(#paint0_linear_2434_12717)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1295 51.4452H15.3445L18.1295 33.0066H8.38195C6.76664 33.0066 6.79449 32.1636 7.32364 31.2681C7.85279 30.3725 7.46289 31.0573 7.51859 30.952C11.1113 24.9462 16.5142 15.9903 23.6996 4.03149H26.4846L23.6996 22.4702H33.4471C34.8118 22.4702 35.0067 23.3394 34.7561 23.8136L34.5611 24.2087C23.5881 42.3576 18.1295 51.4452 18.1295 51.4452Z",
    fill: "url(#paint1_linear_2434_12717)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78718 21H5.64748L3.40532 19.4293L6.78718 13.4544L2.36514 13.4104L0.111816 11.6945C0.328359 11.328 2.06559 11.2986 2.06559 11.2986C3.5358 8.84087 5.0423 4.89384 7.98272 0L10.2063 1.59711L9.06658 9.14268L11.2762 7.73477L13.0555 9.14268C13.0282 9.12266 13.6938 9.4984 13.5912 9.69243L13.5114 9.85412C9.02099 17.2811 6.78718 21 6.78718 21Z",
    fill: "url(#paint2_linear_2434_12717)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55448 19.4153H3.41478L4.55448 11.8698H0.565527C-0.0954984 11.8698 -0.0841016 11.5248 0.132441 11.1583C0.348984 10.7918 0.189427 11.0721 0.212221 11.029C1.68243 8.57128 3.89345 4.90629 6.83388 0.0124512H7.97358L6.83388 7.55802H10.8228C11.3813 7.55802 11.4611 7.91374 11.3585 8.10777L11.2787 8.26946C6.78829 15.6965 4.55448 19.4153 4.55448 19.4153Z",
    fill: "#FFCFAD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2434_12717",
    x1: 23.7565,
    y1: 4,
    x2: 23.7565,
    y2: 55.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8886DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCACCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2434_12717",
    x1: 20.9248,
    y1: 4.03149,
    x2: 20.9248,
    y2: 51.4452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2434_12717",
    x1: 6.85688,
    y1: 0,
    x2: 6.85688,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDADC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A7CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLightning);
export default __webpack_public_path__ + "static/media/img-lightning.1c56e4a5f36e99b75a7b4d9ae53162c0.svg";
export { ForwardRef as ReactComponent };